import { defineStore } from 'pinia';
import { type Dayjs } from 'dayjs';

export const useHistoryStore = defineStore('agentHistory', {
    state: () => ({
        history: [] as { role: 'user' | 'agent', content: string, timestamp: Dayjs }[]
    }),
    actions: {
        addMessage(message: { role: 'user' | 'agent', content: string, timestamp: Dayjs }): void {
            this.history.push(message);
        },
        clearHistory(): void {
            this.history = [];
        }
    }
});